import { takeEvery, call } from 'redux-saga/effects'
import axios from 'portal/utils/axios-msal'

import {
  RecordAlertBulkStatusChangedAction,
  RecordAlertStatusChangedAction,
  RECORD_ALERT_BULK_STATUS_CHANGED,
  RECORD_ALERT_STATUS_CHANGED
} from './actions'

function* editAlertStatusSaga(action: RecordAlertStatusChangedAction) {
  const { accountId, projectId, recordId, recordAlertId, status, callbacks } =
    action
  try {
    yield call(() =>
      axios.put(
        `/accounts/${accountId}/projects/${projectId}/records/${recordId}/recordalerts/${recordAlertId}`,
        {
          status
        },
        {
          validateStatus: status => {
            if (status === 200 || status === 201 || status === 204) {
              return true
            }
            return false
          },
          doNotRedirectOn403: true
        }
      )
    )

    yield call(() => callbacks.onSuccess?.())
  } catch (error) {
    yield call(() => callbacks.onFailure?.(error))
  }
}

function* bulkEditAlertStatusSaga(action: RecordAlertBulkStatusChangedAction) {
  const { accountId, projectId, recordAlertIds, status, callbacks } = action
  try {
    yield call(() =>
      axios.put(
        `/accounts/${accountId}/projects/${projectId}/recordalerts/statuses`,
        {
          recordAlertIds,
          status
        },
        {
          validateStatus: status => {
            if (status === 200 || status === 201 || status === 204) {
              return true
            }
            return false
          },
          doNotRedirectOn403: true
        }
      )
    )

    yield call(() => callbacks.onSuccess?.())
  } catch (error) {
    yield call(() => callbacks.onFailure?.(error))
  }
}

export function* watch() {
  yield takeEvery(RECORD_ALERT_STATUS_CHANGED, editAlertStatusSaga)
  yield takeEvery(RECORD_ALERT_BULK_STATUS_CHANGED, bulkEditAlertStatusSaga)
}
